import UserSubscriptionsCard from '@/components/admin/subscriptions/UserSubscriptionsCard';
import type { User } from '@/models';

interface UserDetailPageTabSubscriptionsProps {
  user: User;
}

export default function UserDetailPageTabSubscriptions({ user }: UserDetailPageTabSubscriptionsProps) {
  return (
    <div className="space-y-8">
      {/* User Subscriptions */}
      <UserSubscriptionsCard user={user} />
    </div>
  );
}
